<div class="{{ theme?.root }}" id="rsaBundle">
  <div class="container {{ theme?.container }}">
    <div class="flex flex-col lg:flex-row items-center">
      <div class="rsa-content w-full lg:w-1/2 py-v-spacing sm:p-v-spacing">
        @if (title) {
          <div id="rsa-title" class="wysiwyg pb-4  mx-auto" [innerHTML]="title"></div>
        }
        @if (description) {
          <div id="rsa-description" class="wysiwyg pb-4 mx-auto" [innerHTML]="description"></div>
        }
        <span class="font-black leading-[27px]">{{ rsaTopListText }}</span>
        <ul id="rsa-bullets" class="grid grid-cols-2 pb-8 mx-auto mt-[10px] flex flex-wrap w-full justify-start">
          @for (bullet of bullets; track bullet; let last = $last) {
            <li
              class="sm:text-baselg w-auto {{ !last ? 'pb-3' : '' }} relative pl-8">
              <fa-icon [icon]="faCheck" class="text-vis-brand-1 fa-1x absolute left-0 top-0"> </fa-icon>
              {{ bullet.bulletItem }}
            </li>
          }
        </ul>
        @if (product || hasCta) {
          <div id="prices"
            class="flex flex-col content-center mx-auto justify-start">
            <span class="pb-6 text-base font-normal leading-6 hidden lg:block">{{ rsaTopButtonText }}</span>
            @if (hasCta) {
              <vision-button class="pt-6 sm:pt-0 sm:pr-v-spacing w-fit" defaultStyle="primary"
              [data]="ctaButtonData"></vision-button>
            }
          </div>
        }
      </div>
      <div class="rsa-image w-full lg:w-1/2 py-v-spacing sm:p-v-spacing">
        <img
          class="mx-auto pb-6"
          [src]="rsaImageUrl"
          [alt]="rsaImageAltText"
          width="459"
          height="459"
          />
        @if (rsaImageFooterTextShow) {
          <div class="flex justify-center w-full">
            <span class="text-base font-normal leading-6 mx-auto">{{ rsaImageFooterText }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
